import React from 'react';
import css from './Impressum.module.css';

const Impressum = () => {
  return (
    <div className={css.content}>
      <p>kitts GmbH</p>
      <p>Geschäftsführer: Alexander Herlach, Marvin Docke</p>
      <p>Oberdorf 4 <br/>
        54497 Morbach</p>
      <p>E-Mail: info@kitts.de</p>
      <p>Eingetragen beim Registergericht: Amtsgericht Wittlich <br/>
        Registernummer: HRB 47590</p>
      <p>Umsatzsteuer ID: DE457518639</p>
      <p>Bildquellen / Fotoagentur:</p>
      <p>IMAGO (imago stock&people GmbH, imago sportfotodienst GmbH) <br/>
        https://www.imago-images.de</p>
    </div>
  );
};

export default Impressum;
